import {configuration} from '../../configuration'

export default {

    help: function () {

        mailTo(configuration.email.contact)

    }
}

/** private **/

function mailTo(url) {

    window.location.href = 'mailto:' + url

}
